module.exports = "module.exports = __webpack_public_path__ + \"assets/data/shows_eng.json\";";